import React, { useState } from 'react';
import './HomePage.css';

function HomePage({ onCreateRoom, onJoinRoom, error }) {
  const [name, setName] = useState('');
  const [roomCode, setRoomCode] = useState('');
  const [mode, setMode] = useState('join'); // create or join (default to join)

  const handleCreate = (e) => {
    e.preventDefault();
    if (name.trim()) {
      onCreateRoom(name.trim());
    }
  };

  const handleJoin = (e) => {
    e.preventDefault();
    if (name.trim() && roomCode.trim()) {
      onJoinRoom(roomCode.trim().toUpperCase(), name.trim());
    }
  };

  return (
    <div className="home-page">
      <div className="home-container">
        <h1 className="title">🎭 Imposter Game</h1>
        <p className="subtitle">Find the imposter among you!</p>

        {error && <div className="error-message">{error}</div>}

        <div className="mode-selector">
          <button
            className={`mode-btn ${mode === 'join' ? 'active' : ''}`}
            onClick={() => setMode('join')}
          >
            Join Room
          </button>
          <button
            className={`mode-btn ${mode === 'create' ? 'active' : ''}`}
            onClick={() => setMode('create')}
          >
            Create Room
          </button>
        </div>

        <form onSubmit={mode === 'create' ? handleCreate : handleJoin} className="home-form">
          <input
            type="text"
            placeholder="Enter your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="input-field"
            required
            maxLength={20}
          />
          
          {mode === 'join' && (
            <input
              type="text"
              placeholder="Enter room code"
              value={roomCode}
              onChange={(e) => setRoomCode(e.target.value.toUpperCase())}
              className="input-field"
              required
              maxLength={6}
            />
          )}

          <button type="submit" className="primary-btn">
            {mode === 'create' ? 'Create Room' : 'Join Room'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default HomePage;

